import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PersonaXRepLeg } from 'src/app/models/PersonaXRepLeg';
import { NavModalComponent } from 'src/app/pages/General/nav-modal/nav-modal.component';
import { DscTituloPaginator, ngClassAceptarModal, strMatTablePaginator } from 'src/app/general/variables';

@Component({
  selector: 'app-modal-ver-repre-legal',
  templateUrl: './modal-ver-repre-legal.component.html',
  styleUrls: ['./modal-ver-repre-legal.component.css']
})
export class ModalVerRepreLegalComponent implements OnInit {

  dataSource: MatTableDataSource<PersonaXRepLeg>;
  matTableColumnsDef = ['Item', 'Representante'];
  matTableColumnsEtiq = ['Ítem', 'Nombre Completo'];
  strMatTablePaginator = strMatTablePaginator;
  ngClassAceptarModal = ngClassAceptarModal;

  @ViewChild(NavModalComponent) navModalC: NavModalComponent;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  listaPersonaXRL: PersonaXRepLeg[] = [];

  constructor(private dialogRef: MatDialogRef<ModalVerRepreLegalComponent>, @Inject(MAT_DIALOG_DATA) public data: any, ) { }

  ngOnInit() {

    this.navModalC.setDatosNavModal2('Representante Legal');

    this.listaPersonaXRL = this.data.listPersonaXRL;

    this._cargarTableMaterial();


  }

  _cargarTableMaterial() {
    this.dataSource = new MatTableDataSource(this.listaPersonaXRL);
    if (this.paginator != null) {this.paginator._intl.itemsPerPageLabel = DscTituloPaginator; }
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;

  }

  _cerrarModal() {

    this.dialogRef.close();

  }

}
